<div *ngIf="isInitLoading" class="iao-wrapper iao-loading-placeholder">
  <ion-spinner name="crescent" class="iao-init-spinner"></ion-spinner>
</div>

<div *ngIf="!isInitLoading" class="iao-wrapper" [class.iao--completed]="isCompleted" [class.iao--scrapped]="isScrapped">

  <!-- Saving overlay (completing / scrapping) -->
  <div *ngIf="isSaving || isScrapping" class="iao-saving-overlay">
    <ion-spinner name="crescent"></ion-spinner>
  </div>

  <!-- Scrapped banner -->
  <div *ngIf="isScrapped" class="iao-scrapped-banner">
    <ion-icon name="trash-outline"></ion-icon>
    <span>{{ 'SCRAPPED' | translate }}</span>
  </div>

  <!-- ═══ CONTACT SECTION ═══════════════════════════════════════════════════ -->
  <div class="iao-section iao-contact-section">
    <ind-form-field [viewData]="contactFormField"
                    [nearMePillsLoader]="nearMePillsLoader"
                    [sharedLocationPillsLoader]="sharedLocationPillsLoader"
                    (handleAdditionalControls)="onContactFormAdditionalControl($event)">
    </ind-form-field>
  </div>

  <!-- ═══ ADDRESS SECTION ═══════════════════════════════════════════════════ -->
  <div class="iao-section iao-address-section">
    <div class="iao-section-label">
      {{ 'ELIGIBLE_ADDRESS' | translate }}
      <span *ngIf="addressLicenseChecking" class="iao-badge iao-badge--loading">
        <ion-spinner name="crescent" style="width:12px;height:12px;"></ion-spinner>
      </span>
    </div>

    <!-- Selected address display (editable) -->
    <div *ngIf="allocation?.contactID && selectedAddress && !isChangingAddress && !isCompleted && !isReadOnly && !isScrapped"
         class="iao-address-display">
      <div class="iao-address-text" (click)="openAddressChange()">{{ selectedAddress }}</div>
      <span *ngIf="selectedAddressObj?.isPrimary" class="iao-badge iao-badge--primary">
        {{ 'ACCOUNT_PRIMARY_CONTACT_NAME' | translate }}
      </span>
      <span *ngIf="addressStateLicenseValid === true && !isPromoMaterial" class="iao-badge iao-badge--valid">
        <ion-icon name="checkmark-outline"></ion-icon>{{ 'LICENSE_VALID' | translate }}
      </span>
      <span *ngIf="addressStateLicenseValid === false && !isPromoMaterial" class="iao-badge iao-badge--invalid">
        <ion-icon name="warning-outline"></ion-icon>{{ 'LICENSE_INVALID' | translate }}
      </span>
      <ng-container *ngIf="isOhioTDDDFlow && addressStateLicenseValid === true">
        <span *ngIf="addressTDDD?.hasCat3" class="iao-badge iao-badge--valid">
          <ion-icon name="checkmark-outline"></ion-icon>{{ 'TDDD_CAT3_LICENSE_LABEL' | translate }}
        </span>
        <span *ngIf="!addressTDDD?.hasCat3 && addressTDDD?.hasCat2" class="iao-badge iao-badge--valid">
          <ion-icon name="checkmark-outline"></ion-icon>{{ 'TDDD_CAT2_LICENSE_LABEL' | translate }}
        </span>
        <span *ngIf="addressTDDD && !addressTDDD.hasCat2 && !addressTDDD.hasCat3" class="iao-badge iao-badge--invalid">
          <ion-icon name="warning-outline"></ion-icon>{{ 'NO_TDDD_LICENSE' | translate }}
        </span>
      </ng-container>
    </div>

    <!-- Address search (dropdown is body-appended overlay) -->
    <div *ngIf="allocation?.contactID && (isChangingAddress || !selectedAddress) && !isCompleted && !isReadOnly && !isScrapped"
         class="iao-inline-search">
      <div #addressSearchWrap class="iao-address-search-wrap">
        <ion-icon name="search-outline" class="iao-search-icon"></ion-icon>
        <input #addressInput
               type="text"
               class="iao-address-search-input"
               [placeholder]="'SEARCH_ADDRESS' | translate"
               [value]="addressSearchText"
               (input)="onAddressSearch($event.target.value)"
               (focus)="onAddressSearchFocus()"
               (blur)="onAddressSearchBlur()" />
        <button *ngIf="addressSearchText || selectedAddress" class="iao-cancel-btn"
                (mousedown)="cancelAddressChange(); $event.preventDefault()">
          <ion-icon name="close-outline"></ion-icon>
        </button>
      </div>
    </div>

    <!-- Read-only / completed: show selected address -->
    <div *ngIf="selectedAddress && (isCompleted || isReadOnly || isScrapped)" class="iao-address-display iao-address-display--readonly">
      <div class="iao-address-text">{{ selectedAddress }}</div>
      <span *ngIf="selectedAddressObj?.isPrimary" class="iao-badge iao-badge--primary">
        {{ 'ACCOUNT_PRIMARY_CONTACT_NAME' | translate }}
      </span>
      <span *ngIf="addressStateLicenseValid === true && !isPromoMaterial" class="iao-badge iao-badge--valid">
        <ion-icon name="checkmark-outline"></ion-icon>{{ 'LICENSE_VALID' | translate }}
      </span>
      <ng-container *ngIf="isOhioTDDDFlow && addressStateLicenseValid === true">
        <span *ngIf="addressTDDD?.hasCat3" class="iao-badge iao-badge--valid">
          <ion-icon name="checkmark-outline"></ion-icon>{{ 'TDDD_CAT3_LICENSE_LABEL' | translate }}
        </span>
        <span *ngIf="!addressTDDD?.hasCat3 && addressTDDD?.hasCat2" class="iao-badge iao-badge--valid">
          <ion-icon name="checkmark-outline"></ion-icon>{{ 'TDDD_CAT2_LICENSE_LABEL' | translate }}
        </span>
        <span *ngIf="addressTDDD && !addressTDDD.hasCat2 && !addressTDDD.hasCat3" class="iao-badge iao-badge--invalid">
          <ion-icon name="warning-outline"></ion-icon>{{ 'NO_TDDD_LICENSE' | translate }}
        </span>
      </ng-container>
    </div>

    <!-- No customer but saved address — show as read-only. Excludes isCompleted/isReadOnly/
         isScrapped (matching the contactID-set blocks above) so this never doubles up with the
         read-only block above it when both a stale/missing contactID and a selectedAddress
         happen to coexist on a completed/read-only/scrapped order. -->
    <div *ngIf="!allocation?.contactID && selectedAddress && !isCompleted && !isReadOnly && !isScrapped" class="iao-address-display iao-address-display--readonly">
      <div class="iao-address-text">{{ selectedAddress }}</div>
    </div>

    <!-- No contact or address yet -->
    <div *ngIf="!allocation?.contactID && !selectedAddress && !isCompleted && !isReadOnly && !isScrapped" class="iao-empty-hint">
      {{ 'SELECT_CUSTOMER' | translate }}
    </div>
  </div>

  <!-- ═══ PRODUCT GRID ═══════════════════════════════════════════════════════ -->
  <div class="iao-section iao-products-section">

    <!-- Section Label -->
    <div class="iao-section-label iao-products-label">
      {{ 'PRODUCT' | translate }}
      <span *ngIf="productRows.length" class="iao-product-count">({{ productRows.length }})</span>
    </div>

    <!-- Inline Add Product (editable state only) -->
    <div *ngIf="!isCompleted && !isReadOnly && !isScrapped" class="iao-inline-search">
      <div #productSearchWrap class="iao-product-search-wrap">
        <ion-icon name="search-outline" class="iao-search-icon"></ion-icon>
        <input type="text"
               class="iao-product-search-input"
               [placeholder]="'ADD_PRODUCT' | translate"
               [value]="productSearchText"
               (input)="onProductSearchInput($event.target.value)"
               (focus)="onProductSearchFocus()"
               (blur)="onProductSearchBlur()" />
        <button *ngIf="productSearchText" class="iao-cancel-btn" (click)="onProductSearchInput('')">
          <ion-icon name="close-outline"></ion-icon>
        </button>
      </div>
    </div>

    <!-- Compact Product Grid -->
    <div *ngIf="productRows.length" class="iao-grid">
      <!-- Grid Header -->
      <div class="iao-grid-header">
        <span class="iao-gc iao-gc-product">{{ 'PRODUCT' | translate }}</span>
        <span *ngIf="!isPromoMaterial" class="iao-gc iao-gc-lot">{{ 'AL_LOT_NUMBER' | translate }}</span>
        <span class="iao-gc iao-gc-qty">{{ 'QUANTITY' | translate }}</span>
        <span class="iao-gc iao-gc-action" *ngIf="!isCompleted && !isReadOnly && !isScrapped"></span>
      </div>

      <!-- Grid Body -->
      <ng-container *ngFor="let product of productRows; let pi = index; trackBy: trackByProductRow">
        <ng-container *ngFor="let lot of product.lots; let li = index; trackBy: trackByLotRow">
          <div class="iao-grid-row"
               [class.iao-grid-row--error]="product.errorMessage && li === 0"
               [class.iao-grid-row--pending]="product.isPending"
               [class.iao-grid-row--group-first]="li === 0"
               [class.iao-grid-row--group-last]="li === product.lots.length - 1">

            <!-- Product name (first lot only) -->
            <div class="iao-gc iao-gc-product">
              <ng-container *ngIf="li === 0">
                <div class="iao-grid-product-name">
                  <ion-spinner *ngIf="product.isPending" name="crescent" class="iao-row-spinner"></ion-spinner>
                  <span class="iao-gpn-text" [title]="product.skuName">{{ product.skuName }}</span>
                  <span *ngIf="!isCompleted && product.onHandQuantity > 0 && !hideSystemOnHandQuantity" class="iao-onhand-inline">({{ product.onHandQuantity }})</span>
                </div>
                <div class="iao-grid-product-meta" *ngIf="!isCompleted">
                  <span *ngIf="product.isControlled"
                        class="iao-micro-pill iao-micro-pill--red"
                        [title]="'CONTROLLED_PRODUCT' | translate">
                    {{ 'CONTROLLED' | translate }}
                  </span>
                  <span *ngIf="product.orderLimit" class="iao-micro-pill iao-micro-pill--blue">{{ 'LIMIT' | translate | titlecase }}: {{ product.orderLimit }}</span>
                  <span *ngIf="product.isUnlimited && !isPromoMaterial" class="iao-micro-pill iao-micro-pill--blue">&#8734;</span>
                  <span *ngIf="product.valueRemaining" class="iao-micro-pill">{{ product.valueRemaining }}</span>
                  <span *ngIf="product.customerDropLimit" class="iao-micro-pill">D:{{ product.customerDropLimit }}</span>
                </div>
              </ng-container>
            </div>

            <!-- Lot name + expiry as secondary (hidden for promo — no lots) -->
            <div *ngIf="!isPromoMaterial" class="iao-gc iao-gc-lot">
              <span class="iao-grid-lot-name">{{ lot.lotName }}</span>
              <span *ngIf="!isCompleted && lot.totalQuantityRemaining > 0 && !hideSystemOnHandQuantity" class="iao-grid-lot-rem">({{ lot.totalQuantityRemaining }})</span>
              <div *ngIf="lot.expiryDisplay" class="iao-grid-lot-expiry">{{ lot.expiryDisplay }}</div>
            </div>

            <!-- Qty stepper -->
            <div class="iao-gc iao-gc-qty">
              <div *ngIf="!isCompleted && !isReadOnly && !isScrapped" class="iao-stepper">
                <button class="iao-stepper-btn" (click)="decrementLot(lot, product)" [disabled]="lot.quantity <= 0" tabindex="0">−</button>
                <input class="iao-qty-input"
                       type="number" min="0"
                       [value]="lot.quantity"
                       (change)="onLotQuantityInput(product, lot, $event)"
                       (blur)="onLotQuantityInput(product, lot, $event)"
                       tabindex="0" />
                <button class="iao-qty-dropdown-btn" (click)="openQuantityDropdown($event, product, lot)" tabindex="0">
                  <ion-icon name="chevron-down-outline"></ion-icon>
                </button>
                <button class="iao-stepper-btn" (click)="incrementLot(product, lot)" [disabled]="!canIncrementLot(product, lot)" tabindex="0">+</button>
              </div>
              <span *ngIf="isCompleted || isReadOnly || isScrapped" class="iao-qty-readonly" [class.iao-qty-readonly--highlight]="isCompleted && lot.quantity > 0">{{ lot.quantity }}</span>
            </div>

            <!-- Remove (per lot) -->
            <div class="iao-gc iao-gc-action" *ngIf="!isCompleted && !isReadOnly && !isScrapped">
              <button class="iao-grid-remove-btn" (click)="removeLotRow(pi, li)" tabindex="0">
                <ion-icon name="close-outline"></ion-icon>
              </button>
            </div>
          </div>
        </ng-container>

        <!-- Error row (compact, spans full width) -->
        <div *ngIf="product.errorMessage" class="iao-grid-error-row">
          <ion-icon name="warning-outline"></ion-icon>
          <span>{{ product.errorMessage }}</span>
        </div>
      </ng-container>

      <!-- TDDD warning footer — Ohio flow only, surfaced when license category
           doesn't permit the current product mix. -->
      <div *ngIf="tdddBlockingMessage" class="iao-grid-footer-warn">
        <ion-icon name="warning-outline"></ion-icon>
        <span>{{ tdddBlockingMessage }}</span>
      </div>
    </div>

    <!-- Empty state (completed/read-only only — no "search and add products above" hint while editable) -->
    <div *ngIf="!productRows.length && (isCompleted || isReadOnly)" class="iao-empty-hint iao-text-center iao-products-empty">
      {{ 'ALLOCATION_NO_PRODUCTS_SELECTED' | translate }}
    </div>
  </div>

  <!-- ═══ SIGNATURE / SUBMIT (59159) ═════════════════════════════════════════ -->
  <div class="iao-signature-section">
    <button *ngIf="!isCompleted && !isReadOnly && !isScrapped && isInlineSampleDropSignatureRequired"
            class="iao-sign-here-btn"
            [class.iao-sign-here-btn--active]="canSign"
            [disabled]="!canSign || isSaving"
            (click)="initiateSignature()">
      <img src="assets/imgs/signature_pending_online.svg" class="iao-sign-icon-img" [class.iao-sign-icon-img--active]="canSign" />
      <span class="iao-sign-box-label">{{ 'SIGN_HERE' | translate }}</span>
    </button>

    <button *ngIf="!isCompleted && !isReadOnly && !isScrapped && !isInlineSampleDropSignatureRequired"
            class="iao-sign-here-btn"
            [class.iao-sign-here-btn--active]="canSign"
            [disabled]="!canSign || isSaving"
            (click)="submitSampleDropWithoutSignature()">
      <span class="iao-sign-box-label">{{ 'SUBMIT' | translate }}</span>
    </button>

    <!-- Completed: view signature button -->
    <button *ngIf="isCompleted && capturedSignature"
            class="iao-sign-here-btn iao-sign-here-btn--completed"
            (click)="viewCompletedSignature()">
      <img src="assets/imgs/action_button_signature.svg" class="iao-sign-icon-img iao-sign-icon-img--active" />
      <span class="iao-sign-box-label">{{ 'VIEW_SIGNATURE' | translate }}</span>
    </button>
  </div>


</div>

<!-- ═══ ADDRESS DROPDOWN (body-portal) ════════════════════════════════════════
     Rendered into a body-appended host via `_renderAddressDropdown`. Using an
     ng-template + EmbeddedViewRef gives us auto-escaped {{ }} interpolation
     (no raw innerHTML) and change-detection-driven re-renders.
============================================================================ -->
<ng-template #addressDropdownTpl>
  <div *ngFor="let addr of filteredAddresses; trackBy: trackAddressOption"
       class="iao-body-addr-option"
       [class.iao-body-addr-option--selected]="selectedAddressObj?.addressId === addr.addressId"
       [class.iao-body-addr-option--pending]="_isAddressLicensePending(addr)"
       (mousedown)="onAddressOptionMousedown($event, addr)">
    <div class="iao-body-addr-option-content">
      <div class="iao-body-addr-option-line1">
        <span class="iao-body-addr-text">{{ addressOptionLine1(addr) }}</span>
        <ng-container *ngIf="addressOptionPillState(addr) as p">
          <span *ngIf="p.primary" class="iao-badge iao-badge--primary">
            {{ 'ACCOUNT_PRIMARY_CONTACT_NAME' | translate }}
          </span>
          <span *ngIf="p.state === 'loading'" class="iao-badge iao-badge--loading">
            {{ 'LOADING' | translate }}
          </span>
          <span *ngIf="p.state === 'valid'" class="iao-badge iao-badge--valid">
            <ion-icon name="checkmark-outline"></ion-icon>{{ 'LICENSE_VALID' | translate }}
          </span>
          <span *ngIf="p.state === 'invalid'" class="iao-badge iao-badge--invalid">
            <ion-icon name="warning-outline"></ion-icon>{{ 'LICENSE_INVALID' | translate }}
          </span>
          <span *ngIf="p.tddd === 'loading'" class="iao-badge iao-badge--loading">
            {{ 'LOADING' | translate }}
          </span>
          <span *ngIf="p.tddd === 'cat3'" class="iao-badge iao-badge--valid">
            <ion-icon name="checkmark-outline"></ion-icon>{{ 'TDDD_CAT3_LICENSE_LABEL' | translate }}
          </span>
          <span *ngIf="p.tddd === 'cat2'" class="iao-badge iao-badge--valid">
            <ion-icon name="checkmark-outline"></ion-icon>{{ 'TDDD_CAT2_LICENSE_LABEL' | translate }}
          </span>
          <span *ngIf="p.tddd === 'invalid'" class="iao-badge iao-badge--invalid">
            <ion-icon name="warning-outline"></ion-icon>{{ 'NO_TDDD_LICENSE' | translate }}
          </span>
        </ng-container>
      </div>
      <div *ngIf="addressOptionLine2(addr) as line2" class="iao-body-addr-option-line2">{{ line2 }}</div>
    </div>
    <ion-icon *ngIf="selectedAddressObj?.addressId === addr.addressId"
              name="checkmark-outline"
              class="iao-body-addr-option-check"></ion-icon>
  </div>
</ng-template>
